import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MaterialModule } from '@app/material.module';

import { SuperuserComponent } from './superuser.component';

@NgModule({
  imports: [CommonModule, FormsModule, BrowserAnimationsModule, MaterialModule],
  declarations: [SuperuserComponent],
  exports: [SuperuserComponent],
})
export class SuperuserModule {}
